import {
  SET_SHARABLE_USERS,
  SET_SHARABLE_TEAMS,
  SET_ACTIVE_TEAM
} from './actionTypes';
import { flattenTree } from 'utils/common';

const initialState = {
  users: [],
  teams: [],
  flatTeams: []
};

const TYPE_USER = 'user';
const TYPE_TEAM = 'team';

const sharableObjects = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHARABLE_USERS:
      const users = action.payload.data.map(u => ({
        id: u.id,
        name: u.name,
        email: u.email,
        type: TYPE_USER,
        teamId: u.team_id
      }));
      return {
        ...state,
        users
      };

    case SET_SHARABLE_TEAMS:
      const { teams } = action.payload;
      const flatTeams = flattenTree(teams).map(ft => ({
        id: ft.id,
        name: ft.name,
        type: TYPE_TEAM,
        isActive: false
      }));
      return {
        ...state,
        teams,
        flatTeams
      };

    case SET_ACTIVE_TEAM:
      const { teamId } = action.payload;
      return {
        ...state,
        flatTeams: state.flatTeams.map(ft => {
          ft.isActive = ft.id === teamId;
          return ft;
        })
      };

    default:
      return state;
  }
};

export default sharableObjects;



// WEBPACK FOOTER //
// ./src/views/Section_SharedTo/flow/reducer.js